import config from '../config';

// 指定された会社区分から作成可能な会社区分を取得する 
// target : 会社区分
export const getCompanyGroup = (target) => {
    let result;
    switch (target) {
        case config.COMPANY_GROUP_REGION: // 国内・北米・欧州一般・その他
            result = [
                config.COMPANY_GROUP_DISTRIBUTOR,
                config.COMPANY_GROUP_TRADING,
                config.COMPANY_GROUP_GENERAL,
                config.COMPANY_GROUP_SBR,
                config.COMPANY_GROUP_AREA,
                config.COMPANY_GROUP_OTHER
            ];
            break;
        case config.COMPANY_GROUP_TRADING: // 商社
            result = [
                config.COMPANY_GROUP_DISTRIBUTOR,
                config.COMPANY_GROUP_AREA,
            ];
            break;

        case config.COMPANY_GROUP_DISTRIBUTOR: // 特約店
            result = [
                config.COMPANY_GROUP_DISTRIBUTOR,
                config.COMPANY_GROUP_GENERAL
            ];
            break;
        case config.COMPANY_GROUP_AREA: // エリア
            result = [config.COMPANY_GROUP_DISTRIBUTOR];
            break;
        case config.COMPANY_GROUP_OTHER: // その他
            result = [config.COMPANY_GROUP_OTHER];
            break;
        default:
            // SBR, 一般事業者 は空で返す
            result = [];
    }
    return result;
};

// 会社の親情報のリストから関連する会社名を - で繋ぐ文字列を返す
// parentChain : 会社名の親情報
export const getParentChain = (parentChain) => {
    let result = "";
    // 選択した会社のチェインを表示 
    const chain = parentChain;
    for (let i = chain.length - 1; i >= 0; i--) {
        result = result + chain[i];
        if (i !== 0) {
            result += ' - ';
        }
    }
    return result;
};

/* **
 * 会社ツリーを更新するための情報を作成する関数
 * @param id: 会社または店舗ID
 * @param tyep: 会社または店舗を更新した時の種別情報(追加・更新・削除など)
 * @param info: 会社または店舗を更新した時の更新情報(会社名や店舗など)
 */
export const createCompanyTreeInfo = (id, tyep, info = null) => {
    const result = {
        'id': id,
        'type': tyep,
        'companyInfo': info
    };
    return result;
};

/**
 * 会社・店舗の ID チェインに SBR が含まれているか判定
 * @param specials: 特別対応が必要な会社コード一覧
 * @param parentIdChain: 会社・店舗 ID のチェイン
 * @param type: 組織のタイプ（会社 or 店舗）
 * @param id: 組織の ID
 */
export const isSbrCompany = (specials, parentIdChain, type, id = null) => {
    let ret = false;
    const sbrCompany = getSpecialCompanyInfo(specials, config.SBR_COMPANY);
    if (sbrCompany.id !== null) {
        // 選択中の会社が SBR かどうか判定
        if (sbrCompany.id === id) {
            ret = true;
        }
        // 親の会社 ID チェインの中に SBR が含まれているか判定
        else {
            const index = parentIdChain.findIndex(el => {
                let result = false;
                if (type === 'shop') {
                    const elems = el.split('-');
                    const index = elems.findIndex(e => e === sbrCompany.id);
                    if (index !== -1) { result = true; }
                    return result;
                } else {
                    const index = parentIdChain.findIndex(el => el === sbrCompany.id);
                    if (index !== -1) { result = true; }
                    return result;
                }
            });
            if (index !== -1) ret = true;
        }
    }
    return ret;
};

/**
 * 引数で設定されたが含まれているか判定
 * @param specials: 特別対応が必要な会社コード一覧
 * @param companyKey: 会社種別(SBR_COMPANY, SOA_COMPANY, SCI_COMPANY, NASI_COMPANY・・)
 * @return {object} 特殊会社のkeyとid 情報 見つからない場合 ({ 'key': null, 'id': null }) 
 */
export const getSpecialCompanyInfo = (specials, companyKey) => {
    // 初期値
    const result = { 'key': null, 'id': null };
    let index = -1;
    if (specials && specials.length > 0) {
        index = specials.findIndex(el => el.key === companyKey);
        if (index !== -1) {
            result.key = specials[index].key;
            result.id = specials[index].id;
        }
    }
    return result;
};

/**
 * 会社・店舗の ID チェインに OID連携ユーザーの所属する会社 が含まれているか判定する
 * @param specials: 特別対応が必要な会社コード一覧
 * @param parentIdChain: 会社・店舗 ID のチェイン
 */
export const isOidExternalAuthUsersCompany = (specials, parentIdChain) => {
    let ret = false;
    // OID連携ユーザーの所属する会社
    const soaCompany = getSpecialCompanyInfo(specials, config.SOA_COMPANY);
    const soaThirdParty = getSpecialCompanyInfo(specials, config.SOA_THIRD_PARTY);
    const sciThirdParty = getSpecialCompanyInfo(specials, config.SCI_THIRD_PARTY);

    const oidLinked = parentIdChain.find(p => p === soaCompany.id || p === soaThirdParty.id || p === sciThirdParty.id);
    if (oidLinked) ret = true;
    return ret;
};

/**
 * 会社・店舗の ID チェインに TMC が含まれているか判定
 */
export const isTMCCompany = (companyId) => {
    return companyId === config.TMC_COMPANY_ID;
};

// IDPcompany: Prd環境でIDPの会社作成が可能になったら関数ごと削除する。
// 会社の作成が可能か返却する
// type : 対象 shop or company
// companyGroup : 会社区分
// isCompanyActive : 廃止区分 true: 有効 false: 廃止
export const isCreateCompany = (type, companyGroup, isCompanyActive) => {
    let result = false;
    // 廃止区分が有効の場合は会社作成できない
    if (!isCompanyActive) return false;
    // 会社かどうか
    if (type === config.ASSIGNED_COMPANY) {
        switch (companyGroup) {
            case config.COMPANY_GROUP_GENERAL: // 一般事業者
            case config.COMPANY_GROUP_SBR: // SBR
                result = false;
                break;
            case config.COMPANY_GROUP_REGION: // 国内・北米・欧州一般・その他
            case config.COMPANY_GROUP_TRADING: // 商社
            case config.COMPANY_GROUP_DISTRIBUTOR: // 特約店
            case config.COMPANY_GROUP_AREA: // エリア
            case config.COMPANY_GROUP_OTHER: // その他
                result = true;
                break;
            default:
                result = false;
                break;
        }
    } else if (type === 'none') {
        result = true;
    }
    return result;
};

export default {
    getCompanyGroup,
    getParentChain,
    createCompanyTreeInfo,
    isSbrCompany,
    getSpecialCompanyInfo,
    isOidExternalAuthUsersCompany,
    isTMCCompany,
    isCreateCompany
};